import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { api } from '../../api/config';

const inputStyle = {
    fieldset: {
        borderRadius: '0px',
        borderWidth: '1px',
        borderColor: '#728085',
        '&.MuiOutlinedInput-notchedOutline': {
            borderColor: '#728085 !important'
        }
    },
    input: {
        color: '#728085',
        '&.MuiInputBase-input::placeholder': {  // ✅ CORRECT SELECTOR
            color: '#728085',
            opacity: 1  // Ensures full opacity
        }
    }
};

export default function SignUp() {

    const [client, setClient] = useState({
        firstname: '',
        lastname: '',
        email: '',
        password: ''
    });

    const handleRequest = () => {

        api.post('/auth/', client)
        .then((res) => {
        })

    }

    return (
        <Box sx={{ height: 'calc(100vh - 114px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box width={{ md: '560px', sm: '80%', xs: '90%' }} marginX={'auto'}>
                <Grid container spacing={4}>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Typography textAlign={'center'} variant="h1" fontFamily={'DanmarkURW'} className='dColor' fontSize={'2.875rem'} fontWeight={'bold'}>Sign up</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Typography variant="body1" className='dColor' fontSize={'1.125rem'} textAlign={'center'}>Sign Up and receive 50 Reward Points.</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Grid container spacing={2}>
                                            <Grid size={6}>
                                                <Box sx={inputStyle}>
                                                    <TextField fullWidth placeholder='Name' value={client.firstname} onChange={(e) => setClient({...client, firstname: e.target.value})} />
                                                </Box>
                                            </Grid>
                                            <Grid size={6}>
                                                <Box sx={inputStyle}>
                                                    <TextField fullWidth placeholder='Surname' value={client.lastname} onChange={(e) => setClient({...client, lastname: e.target.value})} />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={12}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Email Address' value={client.email} onChange={(e) => setClient({...client, email: e.target.value})} />
                                        </Box>
                                    </Grid>
                                    <Grid size={12}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Password' value={client.password} onChange={(e) => setClient({...client, password: e.target.value})} />
                                        </Box>
                                    </Grid>
                                    <Grid size={12}>
                                        <Button fullWidth variant='outlined' className='borderRadiusFlat borderWidth2 buttonPaddingY10 defaultBorderColor' sx={{ backgroundColor: 'text.secondary', color: 'text.primary' }} onClick={() => handleRequest()}>Sign Up</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}